#import "../fragments/newsletter-stub-fragment.graphql"

mutation CreateNewsletter($newsletter: NewsletterCreateInput!) {
    newsletterCreate(input: $newsletter) {
        newsletter {
            ...NewsletterStubFragment
        }
    }
}
